import axios from 'axios'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api'
})

let inMemoryToken = null

function getLocalStorage() {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    return window.localStorage || null
  } catch (error) {
    return null
  }
}

export function setAuthToken(token) {
  inMemoryToken = token || null
  const storage = getLocalStorage()
  if (!storage) {
    return
  }

  if (token) {
    storage.setItem('authToken', token)
  } else {
    storage.removeItem('authToken')
  }
}

export function getStoredToken() {
  if (inMemoryToken) {
    return inMemoryToken
  }

  const storage = getLocalStorage()
  if (!storage) {
    return null
  }

  const stored = storage.getItem('authToken')
  if (stored) {
    inMemoryToken = stored
  }
  return inMemoryToken
}

api.interceptors.request.use((config) => {
  const token = getStoredToken()
  if (token) {
    config.headers = config.headers || {}
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export default api
